import dayjs from "dayjs";
import { getPlainTextLength } from "./homepageHero.helpers";

export const isValidCtaUrl = (value) => {
  const text = value?.trim(); if (!text) return false;
  if (text.startsWith("/")) return !text.startsWith("//");
  try { return ["http:", "https:"].includes(new URL(text).protocol); } catch { return false; }
};
const hex = (value) => /^#[0-9a-f]{6}$/i.test(value || "");

export const validateSlide = (slide, { isNew = false } = {}) => {
  const errors = { buttons: [] };
  if (!getPlainTextLength(slide.title)) errors.title = "Title is required";
  else if (getPlainTextLength(slide.title) > 150) errors.title = "Use 150 characters or fewer";
  if (!getPlainTextLength(slide.title_nl)) errors.title_nl = "Dutch title is required";
  else if (getPlainTextLength(slide.title_nl) > 150) errors.title_nl = "Use 150 characters or fewer";
  if (!getPlainTextLength(slide.subtitle)) errors.subtitle = "Subtitle is required";
  else if (getPlainTextLength(slide.subtitle) > 300) errors.subtitle = "Use 300 characters or fewer";
  if (!getPlainTextLength(slide.subtitle_nl)) errors.subtitle_nl = "Dutch subtitle is required";
  else if (getPlainTextLength(slide.subtitle_nl) > 300) errors.subtitle_nl = "Use 300 characters or fewer";
  if (!slide.audienceType) errors.audienceType = "Audience is required";
  (slide.buttons || []).forEach((button, index) => {
    const buttonErrors = {};
    if (!button.label?.trim()) buttonErrors.label = "Button label is required";
    else if (button.label.trim().length > 40) buttonErrors.label = "Use 40 characters or fewer";
    if (!button.label_nl?.trim()) buttonErrors.label_nl = "Dutch button label is required";
    else if (button.label_nl.trim().length > 40) buttonErrors.label_nl = "Use 40 characters or fewer";
    if (!button.url?.trim()) buttonErrors.url = "Destination URL is required";
    else if (button.url.trim().length > 2048) buttonErrors.url = "URL must be 2048 characters or fewer";
    else if (!isValidCtaUrl(button.url)) buttonErrors.url = "Enter an internal route or http(s) URL";
    if (!hex(button.textColor)) buttonErrors.textColor = "Enter a 6-digit hex color";
    if (button.style === "FILLED" && !hex(button.backgroundColor)) buttonErrors.backgroundColor = "Enter a 6-digit hex color";
    if (button.style === "OUTLINE" && !hex(button.borderColor)) buttonErrors.borderColor = "Enter a 6-digit hex color";
    if (!["FILLED", "OUTLINE", "TEXT"].includes(button.style)) buttonErrors.style = "Choose a button style";
    if (Object.keys(buttonErrors).length) errors.buttons[index] = buttonErrors;
  });
  if (!slide.desktopImage) errors.desktopImage = "Desktop image is required";
  if (!slide.tabletImage) errors.tabletImage = "Tablet image is required";
  if (!slide.mobileImage) errors.mobileImage = "Mobile image is required";
  if (!slide.is_permanent && !slide.isFallback) {
    const start = dayjs(slide.startDateTime); const end = dayjs(slide.endDateTime);
    if (!slide.startDateTime || !start.isValid()) errors.startDateTime = "Valid start date and time is required";
    else if (isNew && start.isBefore(dayjs())) errors.startDateTime = "New schedules cannot start in the past";
    if (!slide.endDateTime || !end.isValid()) errors.endDateTime = "Valid end date and time is required";
    else if (start.isValid() && !end.isAfter(start)) errors.endDateTime = "End must be later than start";
  }
  if (!errors.buttons.some(Boolean)) delete errors.buttons;
  return errors;
};
export const hasErrors = (value) => value && Object.values(value).some((v) => typeof v === "object" ? hasErrors(v) : Boolean(v));
export const countErrors = (value) => value ? Object.values(value).reduce((n, v) => n + (typeof v === "object" ? countErrors(v) : Number(Boolean(v))), 0) : 0;
